var exports = {
  "NQ": "x234b8571--a58344--features-list",
  "pz": "x234b8571--a58344--two-lines",
  "aZ": "x234b8571--a58344--feature-title",
};

module.exports = exports;
